import { combineReducers } from "redux";
import AuthReducer from "../reducers/AuthReducers";
import HelperReducer from "./HelperReducer";
const RootReducer = combineReducers({
  AuthReducer,
  HelperReducer,
});

export default RootReducer;
